import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ConvertorMiladi } from 'utilities/helper/digitToMonth'
interface IItemProps {
    item: IFinancialLoan
    name: string
}
export default function Item({ item, name }: IItemProps) {
    const navigate = useNavigate()
    const { moneyPool, poolship } = useParams()
    return (
        <div
            className=" bg-white border border-[#EFEFEF] rounded-[4px] mx-4 mb-1.5 p-3 cursor-pointer"
            onClick={() =>
                navigate(
                    `/fund/financial-history/funds-detail/${moneyPool}/${poolship}/${item.id}`,
                    {
                        state: { name },
                    }
                )
            }
        >
            <div className=" flex items-center justify-between">
                <p className=" text-base font-bold text-black">
                    {item.poolship_name}
                </p>
                {item.is_fully_repaid ? (
                    <span className=" inline-flex items-center bg-success-2 text-success-on rounded-[10px] px-2.5 py-1 text-xs font-bold">
                        تسویه شده
                    </span>
                ) : (
                    <span className=" inline-flex items-center bg-brand-soft text-brand-deep rounded-[10px] px-2.5 py-1 text-xs font-bold">
                        {item.number_of_repayments} قسط
                    </span>
                )}
            </div>

            <div className=" h-px bg-divider my-2.5" />

            <div className=" flex items-baseline justify-between">
                <span className=" text-sm font-normal text-text-secondary">
                    {item?.pay_date && ConvertorMiladi(item.pay_date)}
                </span>
                <span className=" text-base font-bold text-error-3">
                    {item.amount && item.amount.toLocaleString()} تومان
                </span>
            </div>

            {item.tag && item.tag.length > 0 && (
                <>
                    <div className=" h-px bg-divider my-2.5" />
                    <p className=" text-sm font-normal text-text-body">
                        توضیحات: {item.tag}
                    </p>
                </>
            )}
        </div>
    )
}
